import { render, staticRenderFns } from "./CatAndSearchTerms.vue?vue&type=template&id=bead30a2&scoped=true"
import script from "./CatAndSearchTerms.vue?vue&type=script&lang=js"
export * from "./CatAndSearchTerms.vue?vue&type=script&lang=js"
import style0 from "./CatAndSearchTerms.vue?vue&type=style&index=0&id=bead30a2&prod&scoped=true&lang=css"
import style1 from "./CatAndSearchTerms.vue?vue&type=style&index=1&id=bead30a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bead30a2",
  null
  
)

export default component.exports